





























































































































































































































import type { BDropdown } from 'bootstrap-vue';
import { Vue, Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { Ax } from '@/utils';
import { staffTabAccess, store } from './common';
import * as fzp from './reports/fzp';
import CBudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";


const translates = {
    fzp: {
        get download(): string {
            return i18n.choose(
                'Скачать',
                'Жүктеп алу',
                'Download',
            );
        },
        downloadType: {
            get abpSplit(): string {
                return i18n.choose(
                    'В разрезе АБП',
                    'АБП аясында',
                    'Split by ABP',
                );
            },
            get funcSubgroupSplit(): string {
                return i18n.choose(
                    'В разрезе функц.групп',
                    'Функц.топтар аясында',
                    'Split by functional groups',
                );
            },
        },
        get emptyReport(): string {
            return i18n.choose(
                'Не найдены данные для отчета ФЗП. Необходимо отправить отчеты по формам в свод.',
                'ЕАҚ есебі үшін деректер табылмады. Нысандар бойынша есептерді жиынтыққа жіберу қажет.',
                'No data found for the FZP report. Form-based reports must be submitted for consolidation.',
            );
        },
    },
    tabs: {
        reportsV1: {
            get title(): string {
                return i18n.choose(
                    'Отчеты (архив)',
                    'Отчеты (архив) (каз)',
                    'Reports (archive)',
                );
            },
        },
        reportsV2: {
            get title(): string {
                return i18n.choose(
                    'Отчеты',
                    'Отчеты (каз)',
                    'Reports',
                );
            },
        },
        summaryReports: {
            get title(): string {
                return i18n.choose(
                    'Сводные отчеты',
                    'Сводные отчеты (каз)',
                    'Summary Reports',
                );
            },
        },
    },
};

const paths = {
    initial: '/staffing-table',

    config: '/staffing-table/config',
    data: '/staffing-table/data',
    departmentPositions: '/staffing-table/department-positions',
    departments: '/staffing-table/departments',
    oldV1Reports: '/staffing-table/reports',
    oldV1Report: '/staffing-table/report/',
    oldV1Report2: '/staffing-table/report-2/',
    reports: '/staffing-table/reports-v2',
    report: '/staffing-table/report-v2/',
    fzpReport: '/staffing-table/fzp-report/',
    fileStorage: '/staffing-table/files-storage',
    versions: '/staffing-table/versions',
    summaryReports: '/staffing-table/summary-reports',
    dict: '/staffing-table/dict',
    dictMisc: '/staffing-table/dict-misc',
};


@Component({
    name: 'StaffingTable',
    components: { 'c-budg-form-lst': CBudgetFormsList }
})
export default class Page extends Vue {
    // region Инструкции
    private infoInstructions() {
        const instruction = 'staffing-table-instruction';
        Ax(
            {
                url: '/api/budget/staffing_table/instructions' + instruction, //  Тело файла
                method: 'GET',
                data: null,
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data as BlobPart]));
                const link = document.createElement('a');
                link.href = url;
                const fileName = 'Инструкция пользователя «Штатное расписание»'; // TODO translate

                link.setAttribute('download', fileName + '.pdf');
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                console.error(error.key);
            }
        );
    }

    // noinspection JSMethodCanBeStatic
    private openVideoInstruction() {
        window.open('https://www.youtube.com/playlist?list=PL4jwFLRAXDin-5KQiIzRDPloySgGNkOVg');
    }
    // endregion


    // region Lifecycle
    // noinspection JSUnusedLocalSymbols
    private created() {
        this.$watch('path', () => this.checkOpenedTab());
        // Доступ к вкладке "Сводные отчеты" известен только после загрузки данных
        // доступа (см. common.ts, loadAccessData) — как только они подъедут,
        // перепроверяем, не открыт ли сейчас недоступный пользователю путь
        this.$watch(() => this.accessInitialized, () => this.checkOpenedTab());
    }

    // noinspection JSUnusedLocalSymbols
    private mounted() {
        this.checkOpenedTab();
    }
    // endregion


    // region Общее
    public translates = translates;

    private get path(): string {
        return this.$route.path;
    }

    private get getInitialPath(): string {
       return  paths.initial
    }

    private set path(value: string) {
        this.$router.push({ path: value });
    }

    private replacePath(value: string) {
        this.$router.replace({ path: value });
    }

    // Показ меню разрезов только на странице конкретного FZP-отчёта
    private get fzpReportId(): string | null {
        return fzp.localState.reportId?.toString() ?? null;
    }

    private get fzpReportHasContent(): boolean {
        return fzp.localState.reportHasContent;
    }

    private fzpDownload(exportType: 'SPLIT_BY_ABP' | 'SPLIT_BY_FUNCTIONAL_SUBGROUP') {
        (this.$refs.fzpReportDownloadDropdown as unknown as BDropdown).hide();

        if (!this.fzpReportHasContent) {
            this.$bvToast.toast(this.translates.fzp.emptyReport, {
                variant: 'success',
            });
            return;
        }

        const id = this.fzpReportId;
        if (id === null) {
            return;
        }

        const lang = i18n.locale ?? 'ru';

        window.open(
            `/api/budget/staffing_table/fzp/xlsx-export/fzp-${id}.zip?export-type=${exportType}&lang=${lang}`,
            '_blank',
            'noopener noreferrer',
            false,
        );
    }

    private checkOpenedTab() {
        if (!(
            this.isConfigTabActive
            || this.isDataTabActive
            || this.isDepartmentsTabActive
            || this.isDepartmentPositionsTabActive
            || this.isOldV1ReportsTabActive
            || this.isReportsTabActive
            || this.isFileStorageTabActive
            || this.isVersionsTabActive
            || this.isSummaryTabActive
            || this.isDictTabActive
        )) {
            this.replacePath(paths.data);
            return;
        }

        // Защита от прямого захода по URL на вкладку "Сводные отчеты" без доступа.
        // Проверяем только когда данные доступа уже загружены (accessInitialized),
        // иначе пользователя с доступом может увести с вкладки раньше, чем
        // придёт ответ от /api/budget/staffing_table/user-access
        if (this.isSummaryTabActive && this.accessInitialized && !this.canViewSummaryReports) {
            this.replacePath(paths.data);
        }
    }

    private get storeInitialized(): boolean { return store.initialized; }

    /*** Признак "Данные доступа пользователя загружены" */
    private get accessInitialized(): boolean { return staffTabAccess.initialized; }

    private get canViewSummaryReports(): boolean { return staffTabAccess.canViewSummaryReports; }
    // endregion


    // region Настройка
    private onConfigTabClicked() {
        this.path = paths.config;
    }

    private get isConfigTabActive(): boolean {
        return (this.path === paths.config);
    }
    // endregion


    // region Штатное расписание
    private onDataTabClicked() {
        this.path = paths.data;
    }

    private get isDataTabActive(): boolean {
        return this.path === paths.data;
    }
    // endregion


    // region Подразделения ГУ
    private onDepartmentsTabClicked() {
        this.path = paths.departments;
    }

    private get isDepartmentsTabActive(): boolean {
        return (this.path === paths.departments);
    }
    // endregion


    // region Должности в подразделениях ГУ
    private onDepartmentPositionsTabClicked() {
        this.path = paths.departmentPositions;
    }

    private get isDepartmentPositionsTabActive() {
        return (this.path === paths.departmentPositions);
    }
    // endregion


    // region Старые отчеты 1 версии
    private onOldV1ReportsTabClicked() {
        this.path = paths.oldV1Reports;
    }

    private get isOldV1ReportsTabActive() {
        return ((this.path === paths.oldV1Reports) || this.path.startsWith(paths.oldV1Report) || this.path.startsWith(paths.oldV1Report2));
    }
    // endregion


    // region Отчеты
    private onReportsTabClicked() {
        this.path = paths.reports;
    }

    private get isReportsTabActive() {
        return (
            (this.path === paths.reports)
            ||
            (this.path.startsWith(paths.report))
            ||
            (this.path.startsWith(paths.fzpReport))
        );
    }
    // endregion


    // region Файловое хранилище

    private onFileStorageTabClicked() {
        this.path = paths.fileStorage;
    }

    private get isFileStorageTabActive() {
        return (this.path === paths.fileStorage);
    }
    // endregion


    // region Версии
    private onVersionsTabClicked() {
        this.path = paths.versions;
    }

    private get isVersionsTabActive(): boolean {
        return (this.path === paths.versions);
    }
    // endregion

    // region Сводные отчеты
    private onSummaryReportsTabClicked() {
        this.path = paths.summaryReports;
    }

    private get isSummaryTabActive(): boolean {
        return (this.path === paths.summaryReports);
    }
    // endregion


    // region
    private get isDictTabActive(): boolean {
        return (
            (this.path === paths.dict)
            ||
            (this.path.startsWith(paths.dict + '/'))
            ||
            (this.path.startsWith(paths.dictMisc + '/'))
        );
    }
    // endregion


    private startGame() {
        const backdrop = document.createElement('div');
        backdrop.setAttribute('style', [
            'position: fixed;',
            'top: 0;',
            'left: 0;',
            'right: 0;',
            'bottom: 0;',
            'background-color: rgba(0, 0, 0, 0.315);',
            'z-index: 10000;',
        ].join(' '));

        const modal = document.createElement('iframe');
        modal.setAttribute('style', [
            'position: absolute;',
            'left: calc((100vw - 802px) / 2);',
            'top: calc((100vh - 622px) / 2);',
            'background-color: white;',
            'border-radius: 3px;',
            'border: 1px solid grey;',
            'width: 802px;',
            'height: 622px;',
        ].join(' '));
        modal.src = '/media/game/index.html';

        document.body.append(backdrop);
        backdrop.append(modal);

        backdrop.addEventListener('click', () => { backdrop.remove(); });
    }
}
